import React from "react";
import { Link } from "react-router-dom";
import { OfferHighlight, PRO_ADVANTAGES } from "@/components/home/HomeBottom";
import { CtaButtons } from "@/components/home/shared";
import { useSeo } from "@/lib/seo";
import { pro15Active } from "@/lib/proOffer";

const CODE_STEP = ["Recevez votre code personnel", "Une fois votre compte validé, vous recevez par e-mail votre code -15 %, réservé à votre compte."];
const BASE_STEPS = [
  ["Créez votre compte", "Raison sociale, coordonnées, SIRET (France) ou numéro d'entreprise, adresse de livraison : quelques minutes suffisent."],
  ["Validation par Ozentya", "Chaque compte est vérifié avant l'accès aux prix professionnels. Vous êtes prévenu par e-mail."],
  ["Commandez", "Prix HT, devis, paiement par carte, PayPal ou virement, factures dans votre compte."],
];

const steps = () => (pro15Active() ? [...BASE_STEPS.slice(0, 2), CODE_STEP, ...BASE_STEPS.slice(2)] : BASE_STEPS);

export default function ProAdvantages() {
  useSeo({
    title: "Avantages professionnels et espace pro Ozentya | Coiffeurs et barbiers",
    description: "Espace professionnel Ozentya : prix HT, livraison offerte en France métropolitaine, devis et factures PDF. Conditions d'accès et ouverture de compte.",
    path: "/avantages-professionnels",
  });
  return (
    <div data-testid="pro-advantages-page" className="px-4 sm:px-8 lg:px-16 max-w-6xl mx-auto py-14 sm:py-20">
      <nav aria-label="Fil d'Ariane" className="text-xs text-[var(--oz-muted)]"><Link to="/">Accueil</Link> / Avantages professionnels</nav>
      <h1 className="mt-4 font-serif text-4xl sm:text-5xl leading-tight max-w-3xl">Les avantages de votre espace professionnel Ozentya</h1>
      <p className="mt-5 max-w-2xl text-[var(--oz-muted)] leading-relaxed">Réservé aux salons de coiffure afro et européenne, barbershops, coiffeurs indépendants, boutiques de cosmétiques, salons d'esthétique et autres professionnels de la beauté, partout en France.</p>
      {pro15Active() && <div className="mt-10"><OfferHighlight /></div>}
      <div className="mt-6 grid sm:grid-cols-2 lg:grid-cols-3 gap-4">
        {PRO_ADVANTAGES.map(([Icon, t, d]) => (
          <div key={t} className="rounded-2xl bg-white border border-[var(--oz-border)] p-5"><Icon className="w-5 h-5 text-[var(--oz-gold)]" /><h2 className="mt-3 font-semibold">{t}</h2><p className="mt-1 text-sm text-[var(--oz-muted)] leading-relaxed">{d}</p></div>
        ))}
      </div>
      <h2 className="mt-16 font-serif text-3xl">Comment ouvrir votre compte ?</h2>
      <ol className="mt-6 grid md:grid-cols-4 gap-4">
        {steps().map(([t, d], i) => (
          <li key={t} className="rounded-2xl bg-[var(--oz-bg-2)] p-5"><span className="font-serif text-3xl text-[var(--oz-gold)]">{i + 1}</span><h3 className="mt-2 font-semibold">{t}</h3><p className="mt-1 text-sm text-[var(--oz-muted)] leading-relaxed">{d}</p></li>
        ))}
      </ol>
      <div className="mt-10"><CtaButtons testid="advantages" secondary={{ to: "/espace-pro/connexion", label: "Se connecter" }} /></div>
    </div>
  );
}
